import React from 'react';
import { Col, Row, Typography } from 'components';
import { OnlineShopCard } from '././onlineShopCard';
import { useOnlineShop } from './useOnlineShop';
import { DeleteModal } from './delete';
import { TableEmptyIcon } from 'components/common/icons';

const { Text, Title } = Typography;

export const OnlineShop = React.memo(() => {
  const { onDeleteModalStateChange, onlineShopId, data } = useOnlineShop();
  return (
    <Row>
      {!!data?.length && (
        <Col span={12}>
          {data.map((_data: Record<string, any>) => (
            <OnlineShopCard key={_data.id} data={_data} onDeleteModalOpen={onDeleteModalStateChange} />
          ))}
        </Col>
      )}
      {!data?.length && (
        <Col span={24}>
          <Row gutter={[0, 8]} justify={'center'}>
            <TableEmptyIcon />
            <Col span={24}>
              <Title level={4} className={'font-weight-800 reset-title margin-t-4 center'}>
                No Online Shop
              </Title>
            </Col>
            <Col flex={'365px'} className={'center'}>
              <Text type={'secondary'}>No Online Shop has been added yet. Please click Add New to create one.</Text>
            </Col>
          </Row>
        </Col>
      )}
      <DeleteModal
        openModal={!!onlineShopId}
        onDeleteModalClose={onDeleteModalStateChange}
        dataToDelete={{ id: onlineShopId as string }}
      />
    </Row>
  );
});
